module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#search",
      toString: function () {
        return this.url;
      }
    }